import { render, staticRenderFns } from "./cultura.vue?vue&type=template&id=182310d6&"
import script from "./cultura.vue?vue&type=script&lang=js&"
export * from "./cultura.vue?vue&type=script&lang=js&"
import style0 from "./cultura.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports